module.exports = __webpack_public_path__ + "static/object-8-3adaac8c09393d390e5502a37f760bd9.png";